export default __webpack_public_path__ + "static/media/settingsBlue.d4f94be2.svg";